import React, {useState} from "react"
import styled from "styled-components"
import {Regions} from "@irati-web/fields/region"
import Flex from "@irati/ui/src/Flex"
import Card from "@irati/ui/src/Layout/Card"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {Body, H2} from "@irati/ui/src/Typography"
import {minWidthMedia} from "@irati/ui/src/global/media"
import continent from "@irati-web/wallet/src/images/continent.svg"
import rewardsExplore from "@irati/ui/images/merchanside_checkout_success.png"
import Form from "@irati/ui/src/Form"
import FormattedMessage from "@irati/utils/lang"
import {toQuery} from "@irati-web/perks/src/utils/deals/dealList"
import {WalletRoutes} from "@irati-web/wallet/src/enums/Routes"

const Img = styled.img`
  max-width: 120px;
  align-self: end;
`

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));

  & > * {
    padding: 24px;
  }
`

const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.spacing.three};
`

const Poster = styled.div`
  display: flex;
  overflow: hidden;
  flex-wrap: wrap;
  background-repeat: no-repeat;
  background-position: right center;
  background-size: 40%;
  background-image: url(${continent});
  background-color: ${({theme}) => theme.colors.greys.graphGrey};

  border-top-left-radius: ${({theme}) => theme.spacing.one};
  border-top-right-radius: ${({theme}) => theme.spacing.one};

  ${minWidthMedia.phoneLandscape`
      border-top-right-radius: 0;
      border-top-left-radius: ${({theme}) => theme.spacing.one};
      border-bottom-left-radius: ${({theme}) => theme.spacing.one};
  `}

  & > *:first-child {
    flex: 100;
    flex-basis: 260px;
  }

  & > *:last-child {
    flex: 1;
    justify-content: center;
  }
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
`

const ButtonAlignment = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
`

export default function ViewRewards() {
  const [regions, setRegions] = useState<string[]>([])

  return (
    <Card flush>
      <Container>
        <Poster>
          <TextWrapper>
            <H2>
              <FormattedMessage id="wallet.reward.admin.viewRewards.upsell" />
            </H2>
          </TextWrapper>
          <Flex>
            <Img src={rewardsExplore} alt="" />
          </Flex>
        </Poster>
        <StyledForm>
          <H2>
            <FormattedMessage id="wallet.reward.admin.viewRewards.heading" />
          </H2>
          <div>
            <Body>
              <FormattedMessage id="wallet.reward.admin.viewRewards.body" />
            </Body>
            <Regions value={regions} onChange={setRegions} isClearable flush />
          </div>
          <ButtonAlignment>
            <div />
            <ButtonRouterLink
              disabled={regions.length === 0}
              full
              to={WalletRoutes.FLEXI_REWARD_CATEGORY + "?" + toQuery({regions}, {}, [])}>
              <FormattedMessage id="wallet.reward.admin.viewRewards.cta" />
            </ButtonRouterLink>
          </ButtonAlignment>
        </StyledForm>
      </Container>
    </Card>
  )
}
